host.actions.register({
    // #region Vars
    name: '288a.commerce.cart.delete',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tCart = data;
        if (tCart == null) {
            return this.Cancel();
        }
        let tArgs = {
            title: "Warenkorb " + tCart.cartNumber,
            message: "Möchten Sie den Warenkorb wirklich löschen?",
            successCallback: async () => {
                //Delete
                await this.$host.api.delete(`commerce/carts/${tCart.cartID}`);
                //Store
                this.$store.commit('carts/load');
            }
        };
        return this.Window(await host.notification.showModal2("g-messages-question", tArgs));
    },
    // #endregion
});
export {};
